import * as React from 'react';
import { SVGProps } from 'react';

const IconNodeStartSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 3a1 1 0 0 1 1-1h7.5a1 1 0 0 1 1 1v.5a2.5 2.5 0 0 0 0 5V9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3z" />
    <path d="M10.5 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
  </svg>
);
export default IconNodeStartSizeXs;
